import { cn } from "@dalmatech/ui"

const icon = cn("w-4")

export { icon }
